module.exports = __webpack_public_path__ + "img/symbol_s13.31318f4.svg";